import { Text, Stack, TextLinkButton, Link, Box } from 'braid-design-system';

import CustomSvg from 'src/components/CustomSvg/CustomSvg';

export interface ToolProps {
  enabled: boolean;
  svg: string;
  label: string;
  description: string;
  destination: string;
  htag: string;
  testId: string;
}

const Tool = ({
  enabled,
  svg,
  label,
  description,
  destination,
  htag,
  testId,
}: ToolProps) => (
  <Link href={destination} data-htag={htag} data={{ testid: testId }}>
    <Box
      borderRadius="large"
      height="full"
      padding="medium"
      boxShadow="borderNeutralLight"
    >
      <Stack space="small">
        <Box display="flex" alignItems="center" justifyContent="center">
          <CustomSvg
            svg={svg}
            height={130}
            width={150}
            testId="dashboard-tool-tile-image"
          />
        </Box>

        <Text size="large" weight="strong">
          {enabled ? <TextLinkButton>{label}</TextLinkButton> : label}
        </Text>

        <Text>{description}</Text>
      </Stack>
    </Box>
  </Link>
);

export default Tool;
